import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { postEloquaForm, getReportABugFormCategories, getImprovementFormInfo } from '../services/FormService';

export const useFormPostEloquaForm = createMutationHook(
  collapseParams(collapseParams(postEloquaForm, 'requestBody', 'data'), 'data', 'fields', 'attachments'),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['fields', 'attachments'] },
    ],
  },
);

export const useFormGetReportABugFormCategories = createDCHook(
  'getReportABugFormCategories',
  collapseDataFromCall(getReportABugFormCategories),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
  { maxAge: 300000 },
);

export const useFormGetImprovementFormInfo = createDCHook(
  'getImprovementFormInfo',
  collapseDataFromCall(getImprovementFormInfo),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
  { maxAge: 300000 },
);
